import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Badge, Stat } from "@/components/admin/Ui";

const statusBadge = (s) => {
  if (s === "connected") return <Badge tone="green">Connected</Badge>;
  if (s === "phase_2") return <Badge tone="amber">Phase 2</Badge>;
  if (s === "phase_3") return <Badge tone="neutral">Phase 3</Badge>;
  if (s === "disconnected") return <Badge tone="red">Disconnected</Badge>;
  return <Badge>Unknown</Badge>;
};

export default function Integrations() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/integrations").then(({ data }) => setData(data));
  }, []);

  const items = data?.items || [];
  const counts = data?.counts || {};
  const groups = items.reduce((acc, it) => {
    (acc[it.category] = acc[it.category] || []).push(it);
    return acc;
  }, {});

  return (
    <div data-testid="admin-integrations-page">
      <PageHeader title="Integration operations" subtitle="Connectors & APIs" />
      <div className="p-8 space-y-6">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
          <Stat label="Total" value={counts.total ?? 0} />
          <Stat label="Connected" value={counts.connected ?? 0} hint="MVP — live" />
          <Stat label="Phase 2" value={counts.phase_2 ?? 0} hint="next iteration" />
          <Stat label="Phase 3" value={counts.phase_3 ?? 0} hint="later" />
          <Stat label="Disconnected" value={counts.disconnected ?? 0} hint="needs attention" />
        </div>

        {Object.entries(groups).map(([cat, list]) => (
          <div key={cat} className="bg-white border border-black/10">
            <div className="px-5 py-3 border-b border-black/10 overline">{cat}</div>
            <ul className="divide-y divide-black/5">
              {list.map((it) => (
                <li key={it.name} className="px-5 py-4 flex items-start gap-4" data-testid={`integration-${it.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="font-semibold text-navy">{it.name}</span>
                      {statusBadge(it.status)}
                      <Badge tone={it.tag === "MVP" ? "ember" : "neutral"}>{it.tag}</Badge>
                    </div>
                    <p className="text-sm text-navy/70 mt-1">{it.description}</p>
                    {it.needs && it.needs.length > 0 && (
                      <div className="mt-2 text-[10px] uppercase tracking-widest text-navy/40">
                        Needs: {it.needs.join(" · ")}
                      </div>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
